import { render } from "./additionalTestList.vue?vue&type=template&id=43592ff4"
import script from "./additionalTestList.vue?vue&type=script&lang=js"
export * from "./additionalTestList.vue?vue&type=script&lang=js"

import "./additionalTestList.vue?vue&type=style&index=0&id=43592ff4&lang=scss"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__